import * as React from 'react';

import { Header } from './Header';
import BodyContainer from './bodyContainer';

//import Home from './Home';

type LayoutProps = {
    tokenHandler: any;
    appEnvironment?: string;
};

export default (props: LayoutProps) => (
    <React.Fragment>
        <div className="loader" id="loading" style={{ display: "none" }}>
            <img src="/images/loading.gif" alt="LOADING" />
        </div>
        <Header tokenHandler={props.tokenHandler} appEnvironment={props.appEnvironment} />
        <BodyContainer />
    </React.Fragment>
);
